import React from 'react';
import { Form } from 'react-bootstrap';

const Toggle = ({
  label = 'Remember me',
  value = false,
  callback,
  disabled = false,
  id = 'remember-toggle',
}) => {
  return (
    <div className="d-flex align-items-center">
      <div className="form-switch d-flex align-items-center">
        <Form.Check
          type="switch"
          id={id}
          checked={value}
          onChange={(e) => callback(e.target.checked)}
          disabled={disabled}
          className="m-0 p-2"
        />
      </div>

      <label htmlFor={id} className="user-select-none" style={{ color: 'var(--color-font)' }}>
        {label}
      </label>
    </div>
  );
};

export default Toggle;
